export const QUERY_PARAMS_NAMES = {
  ADDRESS: 'address',
  CHAIN: 'chain',
  DOMAIN: 'domain',
  EMAIL: 'email',
  ENDPOINT: 'endpoint',
  FIO_HANDLE: 'fioHandle',
  FIO_REQUEST_ID: 'fioRequestId',
  HASH: 'hash',
  ID: 'id',
  IMPORTED: 'imported',
  NAME: 'name',
  ORDER_NUMBER: 'orderNumber',
  PUBLIC_KEY: 'publicKey',
  REF_CODE: 'refCode',
  STRIPE_PAYMENT_INTENT: 'payment_intent',
  STRIPE_REDIRECT_STATUS: 'redirect_status',
  TOKEN: 'token',
  TX_IDS: 'txIds',
  USER_ID: 'userId',
} as const;
